import { FieldNames } from 'Src/constants/FieldNames'
import { getAutoCreatedData, getDateTime, OrderModel } from 'Pages/orders_design'
import { getNameEmail } from 'Helpers'
import { UIPlacement } from 'LibNeo'
import { Roles } from 'Constants/Roles'

export enum OrdersListView {
	FULL,
	COLLAPSED,
}

export const FINANCE_PERSON = [FieldNames.FINANCE_PERSON_NAME, FieldNames.FINANCE_PERSON_EMAIL]

export const MANAGER_PHONE_EMAIL = [FieldNames.MANAGER_PHONE, FieldNames.MANAGER_EMAIL]

export const DESICION_MAKER = [FieldNames.DECISION_MAKER_PHONE, FieldNames.DECISION_MAKER_EMAIL]

export const ORGANIZATION_DATA = [
	FieldNames.MCC_CODE_NAME,
	FieldNames.OPERATION_AVERAGE_SUM,
	FieldNames.TURN_OVER,
	FieldNames.ORGADDRESS,
	FieldNames.ACCOUNT_NUMBER,
	FieldNames.ACCOUNT_BANK_BIC,
]

export const EQUIPMENT_INSTALLATION = [
	FieldNames.EQUIP_TYPE_RU,
	FieldNames.EQUIP_AMOUNT,
	FieldNames.EQUIP_CONNECT_TYPE,
	FieldNames.INSTALL_DATE,
	FieldNames.INSTALL_REGION_NAME,
	FieldNames.POSADDRESS,
	FieldNames.QUESTIONS_CONTACT_PHONE,
	FieldNames.POS_NAME,
]

export const OTHERS = [
	FieldNames.NOTICE_NUMBER,
	FieldNames.LOTNUMBER,
	FieldNames.CUSTOMERINN,
	FieldNames.DEAL_AMOUNT,
	FieldNames.GUARANTEETYPE,
	FieldNames.DEAL_SUBJECT_ID,
	FieldNames.ATTACHMENTS,
	FieldNames.ADD_INFO,
]

export const BANK_DEPARTMENT = [
	FieldNames.REGION_ID,
	FieldNames.CITY_ID,
	FieldNames.MERCHANT_BRANCH_ID,
]

export enum RBIDOS_TYPES {
	FREE = 'free',
	PAID = 'paid',
}

export const ONLINE_FIELDS = [
	...FINANCE_PERSON,
	...MANAGER_PHONE_EMAIL,
	...DESICION_MAKER,
	...ORGANIZATION_DATA,
	...EQUIPMENT_INSTALLATION,
]

export enum ORDER_SOURCE_TYPE {
	LANDING = 'landing',
	LK = 'lk',
	API = 'api',
}

export const formatFields = [FieldNames.OPERATION_AVERAGE_SUM, FieldNames.TURN_OVER]

export const MIN_COMMENT_LENGTH = 1

export interface Description {
	title: string
	value: string | JSX.Element
	allowed?: boolean
}

export const getRequisitesData = (item: OrderModel): Description[] => {
	return [
		{
			title: 'Партнер',
			value: item.partner?.name,
		},
		{
			title: 'Подразделение банка',
			value: item.merchant_branch?.address,
		},
		{
			title: 'Подразделение',
			value: item.department?.name,
		},

		{
			title: 'Сотрудник',
			value: `${getNameEmail(item.created_by_user?.name).name} · ${
				getNameEmail(item.created_by_user?.name).email
			}`,
		},
		{
			title: 'Дата создания заявки',
			value: `${getDateTime(item?.created_at)}`,
		},
		{
			title: 'Направление',
			value: item.channel?.name,
		},
		{
			title: 'Тер. банк',
			value: item.manager?.territorial_bank?.name,
		},
		{
			title: 'Тер. менеджер',
			value: `${getNameEmail(item.manager?.name).name} · ${getNameEmail(item.manager?.name).email}`,
		},
	]
}

export const getBankDivisionData = (item: OrderModel): Description[] => {
	return [
		{
			title: 'Регион',
			value: item.region?.name,
		},
		{
			title: 'Город',
			value: item.city?.name,
		},
		{
			title: 'Адрес',
			value: item.merchant_branch?.address,
		},
	]
}

export const getOtherData = (item: OrderModel): Description[] => {
	return [
		{
			title: 'Номер извещения',
			value: item?.notice_number,
		},
		{
			title: 'Номер лота',
			value: item?.lot_number,
		},
		{
			title: 'ИНН бенефициара',
			value: item?.customer_inn,
		},

		{
			title: 'Сумма сделки',
			value: item?.deal_amount && `${Math.trunc(item?.deal_amount)} ₽`,
		},
		{
			title: 'Вид гарантии',
			value: item?.guaranteetype,
		},

		{
			title: 'Тип сделки',
			value: item?.deal_subject?.name,
		},
		{
			title: 'Комментарий',
			value: item?.add_info,
		},
	]
}

export const getOrderSourceData = (item: OrderModel): Description[] => {
	return [
		{
			title: 'Сервис',
			value: getAutoCreatedData(item)?.description,
		},
		{
			title: 'Номер',
			value: item[getAutoCreatedData(item)?.field]?.id,
		},
		{
			title: 'Дата',
			value: item?.autoorder_source
				? getDateTime(item?.autoorder_created_at)
				: getDateTime(item[getAutoCreatedData(item)?.field]?.created_at),
		},
	]
}

export const basePopoverProps = {
	okText: 'Да',
	cancelText: 'Нет',
	placement: UIPlacement.LEFT,
}

export const buttonsBlockRoles = [
	Roles.RUKOVODITEL,
	Roles.MANAGER,
	Roles.HEAD_MANAGER,
	Roles.SUPER_ADMIN,
	Roles.ADMIN,
]
